import './App.css';
import AmortizationModule from './components/AmortizationModule';
function App() {
  return (
      <AmortizationModule/>
  );
}

export default App;
